// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type SyntheticEvent } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import range from 'lodash/range';
import Pagination from '@atlaskit/pagination';
import { token } from '@atlaskit/tokens';
import { defineMessages } from '@atlassian/jira-intl';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import type { AnalyticsData } from '../../state/analytics/types.tsx';

const messages = defineMessages({
	previousButton: {
		id: 'project-components.paginator.previous-button',
		defaultMessage: 'Prev',
		description: 'Previous page button of pagination in components directory',
	},
	nextButton: {
		id: 'project-components.paginator.next-button',
		defaultMessage: 'Next',
		description: 'Next page button of pagination in dashboards directory',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div<{ totalPages: number }>(
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) => ({
		marginTop: token('space.300'),

		marginBottom: token('space.300'),
		marginLeft: token('space.negative.200'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		display: props.totalPages <= 1 ? 'none' : 'block',
	}),
);

type Props = {
	intl: IntlShape;
	currentPage: number;
	totalPages: number;
	onPageChange: (arg1: number) => void;
	analyticsData: AnalyticsData;
};

// eslint-disable-next-line jira/react/no-class-components
class PaginatorView extends PureComponent<Props> {
	onPageChange = (event: SyntheticEvent<unknown>, page: number) => {
		this.props.onPageChange(page);
	};

	render() {
		const {
			currentPage,
			totalPages,
			intl: { formatMessage },
		} = this.props;

		return (
			<Container
				totalPages={totalPages}
				data-test-id="project-directories.components.paginator.container"
			>
				<Pagination
					testId="project-directories.components.paginator.pagination"
					selectedIndex={currentPage - 1}
					onChange={this.onPageChange}
					pages={range(1, totalPages + 1)}
					previousLabel={formatMessage(messages.previousButton)}
					nextLabel={formatMessage(messages.nextButton)}
				/>
			</Container>
		);
	}
}

export default injectIntl(PaginatorView);
